import { render } from "./hotCity.vue?vue&type=template&id=6e648e96&scoped=true"
import script from "./hotCity.vue?vue&type=script&lang=js"
export * from "./hotCity.vue?vue&type=script&lang=js"

import "./hotCity.vue?vue&type=style&index=0&id=6e648e96&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/hw-employment-front-end-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e648e96"]])

export default __exports__